import { BeneficiaryType, Flow } from "@ctypes";

export const INVEST_TOGETHER = "INVEST_TOGETHER" as const;

export type AddBeneficiaryTypeSelectionState = {
  [BeneficiaryType.Child]: boolean;
  [BeneficiaryType.Self]: boolean;
  [INVEST_TOGETHER]: boolean;
};

export type AddBeneficiaryTypeSelectionAction = {
  type: AddBeneficiaryTypeSelectionType;
};

export type AddBeneficiaryTypeSelectionType =
  | BeneficiaryType.Child
  | BeneficiaryType.Self
  | typeof INVEST_TOGETHER;

export type AddBeneficiaryTypeRouteProps = {
  flow?: Flow;
};
